import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  DeleteProposalItemModel,
  SearchProposalItemModel,
} from '../../../models/proposal-item.model'
@Injectable({
  providedIn: 'root',
})
export class ProposalItemService {
  private baseUrl = environment.baseUrl
  private resource = 'ItemProposta'

  constructor(private httpClient: HttpClient) {}

  public createProposalItem(
    model: any,
    // model: CreateProposalItemModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/create`, model)
  }

  public editProposalItem(
    model: any,
    // model: EditProposalItemModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/edit`, model)
  }

  public deleteProposalItem(model: DeleteProposalItemModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/delete`, model)
  }

  public listPagedProposalItem(page: number, rows = 15): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedProposalItemByProposal(
    idProposal: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/proposta/${idProposal}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchProposalItem(
    // model: SearchProposalItemModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/search`, model)
  }

  public listProposalItem(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listall`)
  }

  public listProposalItemByProposal(idProposal: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/proposta/${idProposal}`)
  }

  public getProposalItembyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/${id}`)
  }

  public getProposalItembyProposalId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listall/proposta/${id}`)
  }

  public getProposalServicoAdicionalbyProposalId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}PropostaServicoAdicional/Proposta/${id}`)
  }

  public searchPagedProposalItem(
    page: number,
    rows = 15,
    model: any,
    orderBy: string = ''
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}&orderBy=${orderBy}`,
      model,
    )
  }
  public searchPagedByProposalLogistics(
    page: number,
    rows = 15,
    model: any,
    orderBy: string = '',
  ): Observable<ResponseRequestModel> {
    const [field, direction] = orderBy.split(':')
    const orderParams = field ? `&orderBy=${field}&orderDirection=${direction === 'asc' ? 'asc' : 'desc'}` : ''
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/pos-proposta?pageNumber=${page}&pageSize=${rows}${orderParams}`,
      model,
    )
  }

  public createProposalItemWithItineraries(
    model: any,
    // model: CreateProposalItemModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/create/item-itinerarios`, model)
  }
  public createProposalItemWithItinerariesPostProposal(
    model: any,
    // model: CreateProposalItemModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create/item-itinerarios/pos-proposta`,
      model,
    )
  }
  public editProposalItemWithItineraries(
    model: any,
    // model: CreateProposalItemModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/edit/item-itinerarios`, model)
  }

  public removeProposalItem(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/remove/item/${id}`, {
      itemId: id,
    })
  }

  public duplicateProposalItem(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/duplicar/${id}`)
  }

  //   teste
}
